export const UNKNOWN_HOST_DIGEST = 'UNKNOWN_HOST';
